import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/step_check.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "page_header" }
const _hoisted_4 = { id: "input-wrapper" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "company-input" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "businesstype-inputs" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "business-inputs" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "company-input" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "phone-inputs" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "company-input" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "business-inputs" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "email-inputs" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "address-inputs" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "company-input" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "address-inputs" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "company-input" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "company-input" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "filebox" }
const _hoisted_33 = {
  key: 0,
  class: "file-name"
}

import { Member } from "@/common/types";
import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TotalUserDetailView',
  props: {
    member: {},
    회원구분: {}
  },
  emits: ["setUser"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const form = ref({
  companyName: "",
  businessType: "개인",
  businessNumber1: "",
  businessNumber2: "",
  businessNumber3: "",
  representativeName: "",
  managerName: "",
  phoneNumber1: "",
  phoneNumber2: "",
  phoneNumber3: "",
  managerPhone1: "",
  managerPhone2: "",
  managerPhone3: "",
  email1: "",
  email2: "",
  companyAddress1: "",
  companyAddress2: "",
  addressDetail: "",
  companyAddress21: "",
  companyAddress22: "",
  addressDetail2: "",
  remarks: "",
  file: null as File | null, // 파일 초기화
});
onMounted(() => {
  form.value = {
    companyName: props.member.사업자명,
    businessType: props.member.사업자구분,
    businessNumber1: props.member.사업자번호.slice(0, 3),
    businessNumber2: props.member.사업자번호.slice(3, 5),
    businessNumber3: props.member.사업자번호.slice(5, 10),
    representativeName: props.member.대표자명,
    managerName: props.member.담당자명,
    phoneNumber1: props.member.대표자전화번호.slice(0, 3),
    phoneNumber2: props.member.대표자전화번호.slice(3, 7),
    phoneNumber3: props.member.대표자전화번호.slice(7, 11),
    managerPhone1: props.member.담당자전화번호.slice(0, 3),
    managerPhone2: props.member.담당자전화번호.slice(3, 7),
    managerPhone3: props.member.담당자전화번호.slice(7, 11),
    email1: props.member.담당자이메일.split("@")[0],
    email2: props.member.담당자이메일.split("@")[1],
    companyAddress1: props.member.우편번호,
    companyAddress2: props.member.주소,
    addressDetail: props.member.상세주소,
    companyAddress21: props.member.우편번호2,
    companyAddress22: props.member.주소2,
    addressDetail2: props.member.상세주소2,
    remarks: props.member.비고,
    file: null,
  }
})
const uploadedFileName = ref("");
const businessNumber1Input = ref<HTMLInputElement | null>(null);
const businessNumber2Input = ref<HTMLInputElement | null>(null);
const businessNumber3Input = ref<HTMLInputElement | null>(null);

const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files ? target.files[0] : null;
  form.value.file = file;
  uploadedFileName.value = file ? file.name : "";
};

const validateForm = (): boolean => {
  if (!form.value.companyName) {
    alert("사업자명을 입력해주세요.");
    return false;
  }
  if (!form.value.businessNumber1 || !form.value.businessNumber2 || !form.value.businessNumber3) {
    alert("사업자번호를 모두 입력해주세요.");
    return false;
  }
  if (!form.value.managerName) {
    alert("대표자명을 입력해주세요.");
    return false;
  }
  if (!form.value.phoneNumber1 || !form.value.phoneNumber2 || !form.value.phoneNumber3) {
    alert("대표자 전화번호를 모두 입력해주세요.");
    return false;
  }
  if (!form.value.email1 || !form.value.email2) {
    alert("담당자 이메일을 입력해주세요.");
    return false;
  }
  if (!form.value.companyAddress1 || !form.value.companyAddress2) {
    alert("우편번호와 주소를 입력해주세요.");
    return false;
  }
  return true;
};

const signUp = async () => {
  if (!validateForm()) return;

  emit("setUser", form.value);
};

const searchAddr = (seq: number) => {
  const daum = (window as any).daum;
  new daum.Postcode({
    oncomplete(data: any) {
      if(seq === 1) {
        form.value.companyAddress1 = data.zonecode;
        form.value.companyAddress2 = data.address;
      } else {
        form.value.companyAddress21 = data.zonecode;
        form.value.companyAddress22 = data.address;
      }
    },
  }).open();
};

// 숫자만 입력 가능하도록 처리하는 함수
const handleBusinessNumber = (currentField: 'businessNumber1' | 'businessNumber2' | 'businessNumber3', nextField: '' | 'businessNumber2' | 'businessNumber3', maxLength: number) => {
  // 현재 입력된 값
  let value = form.value[currentField] as string;
  
  // 숫자만 추출
  const numericValue = value.replace(/[^0-9]/g, '');
  
  // v-model 업데이트
  form.value[currentField] = numericValue;
  
  // 최대 길이에 도달하고 다음 필드가 있으면 다음 필드로 포커스 이동
  if (numericValue.length >= maxLength && nextField) {
    const nextInput = {
      'businessNumber2': businessNumber2Input,
      'businessNumber3': businessNumber3Input
    }[nextField];
    
    if (nextInput && nextInput.value) {
      nextInput.value.focus();
    }
  }
};
const formatBusinessNumber = () => {
  const num1 = form.value.businessNumber1.padStart(3, '0');
  const num2 = form.value.businessNumber2.padStart(2, '0');
  const num3 = form.value.businessNumber3.padStart(5, '0');
  
  return `${num1}-${num2}-${num3}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "회원가입(" + _toDisplayString(props.회원구분 == '통합' ? '통합' : '일반') + "회원)", 1),
      _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"page_header_line\" data-v-283b0b7d></div><div class=\"steps\" data-v-283b0b7d><div class=\"step active\" data-v-283b0b7d><div class=\"step_circle\" data-v-283b0b7d><img src=\"" + _imports_0 + "\" data-v-283b0b7d><div class=\"step_label\" data-v-283b0b7d>약관동의</div></div></div><div class=\"step active\" data-v-283b0b7d><div class=\"step_line\" data-v-283b0b7d></div><div class=\"step_circle\" data-v-283b0b7d><div class=\"step_label\" data-v-283b0b7d>정보입력</div></div></div><div class=\"step\" data-v-283b0b7d><div class=\"step_line\" data-v-283b0b7d></div><div class=\"step_circle\" data-v-283b0b7d><div class=\"step_label\" data-v-283b0b7d>인증서등록</div></div></div><div class=\"step\" data-v-283b0b7d><div class=\"step_line\" data-v-283b0b7d></div><div class=\"step_circle\" data-v-283b0b7d><div class=\"step_label\" data-v-283b0b7d>심사 후 승인</div></div></div></div>", 2))
    ]),
    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "join_header" }, "정보입력", -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[31] || (_cache[31] = _createElementVNode("label", { for: "companyName" }, "사업자명", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "companyName",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.companyName) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.companyName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[34] || (_cache[34] = _createElementVNode("label", { for: "businessType" }, "사업자구분", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "개인",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.businessType) = $event))
              }, null, 512), [
                [_vModelRadio, form.value.businessType]
              ]),
              _cache[32] || (_cache[32] = _createTextVNode(" 개인 "))
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "법인",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.businessType) = $event))
              }, null, 512), [
                [_vModelRadio, form.value.businessType]
              ]),
              _cache[33] || (_cache[33] = _createTextVNode(" 법인 "))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[35] || (_cache[35] = _createElementVNode("label", { for: "businessNumber" }, "사업자번호", -1)),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "businessNumber1",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.businessNumber1) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (handleBusinessNumber('businessNumber1', 'businessNumber2', 3))),
              maxlength: "3",
              ref_key: "businessNumber1Input",
              ref: businessNumber1Input,
              autocomplete: "off"
            }, null, 544), [
              [_vModelText, form.value.businessNumber1]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "businessNumber2",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.businessNumber2) = $event)),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (handleBusinessNumber('businessNumber2', 'businessNumber3', 2))),
              maxlength: "2",
              ref_key: "businessNumber2Input",
              ref: businessNumber2Input,
              autocomplete: "off"
            }, null, 544), [
              [_vModelText, form.value.businessNumber2]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "businessNumber3",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.businessNumber3) = $event)),
              onInput: _cache[8] || (_cache[8] = ($event: any) => (handleBusinessNumber('businessNumber3', '', 5))),
              maxlength: "5",
              ref_key: "businessNumber3Input",
              ref: businessNumber3Input,
              autocomplete: "off"
            }, null, 544), [
              [_vModelText, form.value.businessNumber3]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[36] || (_cache[36] = _createElementVNode("label", { for: "managerName" }, "대표자명", -1)),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "managerName",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.representativeName) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.representativeName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[37] || (_cache[37] = _createElementVNode("label", { for: "phoneNumber" }, "대표자 전화번호", -1)),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "phoneNumber1",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.phoneNumber1) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.phoneNumber1]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "phoneNumber2",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.phoneNumber2) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.phoneNumber2]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "phoneNumber3",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.phoneNumber3) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.phoneNumber3]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[38] || (_cache[38] = _createElementVNode("label", { for: "managerName" }, "담당자명", -1)),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "managerName",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.managerName) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.managerName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[39] || (_cache[39] = _createElementVNode("label", { for: "managerPhone" }, "담당자 전화번호", -1)),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "managerPhone1",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.managerPhone1) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.managerPhone1]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "managerPhone2",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.managerPhone2) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.managerPhone2]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "managerPhone3",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.managerPhone3) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.managerPhone3]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[41] || (_cache[41] = _createElementVNode("label", { for: "taxEmail" }, "담당자 이메일", -1)),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "email1",
              type: "text",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.email1) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.email1]
            ]),
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "dot" }, "@", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "email2",
              type: "text",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.email2) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.email2]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[42] || (_cache[42] = _createElementVNode("label", { for: "companyAddress" }, "주소", -1)),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "address1",
              readonly: "",
              type: "search",
              id: "companyAddress1",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.companyAddress1) = $event)),
              onClick: _cache[20] || (_cache[20] = ($event: any) => (searchAddr(1)))
            }, null, 512), [
              [_vModelText, form.value.companyAddress1]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "address2",
              readonly: "",
              type: "text",
              id: "companyAddress2",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.companyAddress2) = $event)),
              onClick: _cache[22] || (_cache[22] = ($event: any) => (searchAddr(1)))
            }, null, 512), [
              [_vModelText, form.value.companyAddress2]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[43] || (_cache[43] = _createElementVNode("label", { for: "addressDetail" }, "상세주소", -1)),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "addressDetail",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.value.addressDetail) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.addressDetail]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[44] || (_cache[44] = _createElementVNode("label", { for: "companyAddress" }, "주소2", -1)),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: "address1",
              readonly: "",
              type: "search",
              id: "companyAddress1",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((form.value.companyAddress21) = $event)),
              onClick: _cache[25] || (_cache[25] = ($event: any) => (searchAddr(2)))
            }, null, 512), [
              [_vModelText, form.value.companyAddress21]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "address2",
              readonly: "",
              type: "text",
              id: "companyAddress2",
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.value.companyAddress22) = $event)),
              onClick: _cache[27] || (_cache[27] = ($event: any) => (searchAddr(2)))
            }, null, 512), [
              [_vModelText, form.value.companyAddress22]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[45] || (_cache[45] = _createElementVNode("label", { for: "addressDetail" }, "상세주소2", -1)),
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "addressDetail",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((form.value.addressDetail2) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.addressDetail2]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[46] || (_cache[46] = _createElementVNode("label", { for: "remarks" }, "비고", -1)),
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "remarks",
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form.value.remarks) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, form.value.remarks]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[48] || (_cache[48] = _createElementVNode("label", { for: "file" }, "사업자등록증", -1)),
          _createElementVNode("div", _hoisted_32, [
            (uploadedFileName.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(uploadedFileName.value), 1))
              : _createCommentVNode("", true),
            _cache[47] || (_cache[47] = _createElementVNode("label", { for: "file" }, "파일 첨부 +", -1)),
            _createElementVNode("input", {
              type: "file",
              id: "file",
              onChange: handleFileUpload
            }, null, 32)
          ])
        ])
      ]),
      _createElementVNode("div", { class: "submit-btn" }, [
        _createElementVNode("button", {
          type: "submit",
          class: "submit-button",
          onClick: signUp
        }, "다음")
      ])
    ])
  ]))
}
}

})